import { DeepThoughtsSummaryCard } from "@/components/shared/deep-thoughts-summary-card";
import type { ActivityResultCardProps } from "@/lib/activities/registry";

export function DeepThoughtsResultCard({
  participants,
  onClick,
}: ActivityResultCardProps) {
  return (
    <DeepThoughtsSummaryCard
      teenName={participants.teen.name}
      teenAvatarUrl={participants.teen.avatarUrl}
      onClick={onClick}
    />
  );
}
